import { EditOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Table,  Typography, Input, message } from "antd";
import { useEffect, useState } from "react";
import { useGetVirtualEventsList } from "features/events/use-cases/get-virtuaEvents";
import { useParams } from "react-router-dom";
import { useEventsVirtualEvents } from "features/events/use-cases/create-events-virtualEvents";

export const VirtualEventsView = (tabs:any) => {
    const { Title, Text } = Typography;
    const { id } = useParams();
    const { mutate } = useEventsVirtualEvents();
    const tabsValue=tabs?.tabs
    const { data, refetch } = useGetVirtualEventsList({
        flag: "CategoryList",
        EventId: id
    } as any);
   
   
    // ✅ keep index only for UI, NOT identity
    const [editingRowIndex, setEditingRowIndex] = useState<number | null>(null);
    const [tempDistanceId, setTempDistanceId] = useState("");
    
    const [errorIndex, setErrorIndex] = useState<number | null>(null);
    const getPriceType = (priceType: any) => {
        const value = Number(priceType);

        switch (value) {
            case 2:
                return "Early Bird";
            case 3:
                return "Late";
            case 1:
            default:
                return "Normal";
        }
    };
 useEffect(() => {
    if (tabsValue?.tabs === "6") {
        refetch();
    }

    // reset state on tab change
    setTempDistanceId("");
    setEditingRowIndex(null);
    setErrorIndex(null);

}, [tabsValue]);
    const handleEdit = (record: any, index: number) => {

        setEditingRowIndex(index);
        setTempDistanceId(record?.DistanceId || "");
    };

    const handleSave = (record: any, index: number) => {
        const value = String(tempDistanceId ?? "").trim();

        if (!value) {
            setErrorIndex(index);
            
return;
        }

        const isNumberOnly = /^\d+$/.test(value);

        if (!isNumberOnly) {
            setErrorIndex(index);
            message.error("Distance ID must contain only numbers");
            
return;
        }

        setErrorIndex(null);

        const payload: any = {
            flag: "SAVEDISTANCEID",
            distanceId: tempDistanceId,   // ✅ correct value
            categoryId: record?.Id, // ✅ FIXED
        };

        mutate(payload, {
            onSuccess: () => {
                message.success("Distance Id updated successfully ");
                refetch(); // ✅ THIS FIXES YOUR ISSUE

                setEditingRowIndex(null);
                setTempDistanceId("");
            }
        });
    };

    const columns = [
        {
            title: "Category",
            dataIndex: "CategoryName",
            key: "category"
        },
        {
            title: "Type",
            key: "type",
            render: (_: any, record: any) => (
                <Text>
                    {getPriceType(record.PriceType)}
                </Text>
            )
        },
        {
            title: "Distance ID",
            dataIndex: "DistanceId",
            key: "distanceId",
            render: (_: any, record: any, index: number) => {
                const isEditing = editingRowIndex === index;

                return isEditing ? (
                    <Input
                        value={tempDistanceId}
                        status={errorIndex === index ? "error" : ""}
                        placeholder={errorIndex === index ? "Only numbers allowed" : "Enter Distance ID"}
                        onChange={(e) => {
                            setTempDistanceId(e.target.value);
                            if (e.target.value.trim()) {
                                setErrorIndex(null); // 
                            }
                        }}
                    />
                ) : (
                    <Text strong={!!record.DistanceId}>
                        {record.DistanceId || (
                            <Text type="secondary" style={{ fontStyle: "italic" }}>
                                Not assigned
                            </Text>
                        )}
                    </Text>
                );
            }
        },
        {
            title: "Action",
            key: "action",
            align: "center" as const,
            render: (_: any, record: any, index: number) => {
                const isEditing = editingRowIndex === index;

                return isEditing ? (
                    <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        onClick={() => handleSave(record, index)}
                    >
                        Save
                    </Button>
                ) : (
                    <Button
                        type="text"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record, index)}
                    />
                );
            }
        },
    ];

    return (
        <>
            <Title level={5} style={{ marginBottom: 15 }}>
                Tickets · Distance ID
            </Title>

            <Table
                dataSource={(data as any)?.CategoryList || []}
                columns={columns}
                pagination={false}
                bordered={false}
                size="middle"
                rowKey={(record: any) => record.id || record.CategoryId}
            />
        </>
    );
};